export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-22 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl overflow-hidden">
          <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
              <i className="ri-download-cloud-2-line"></i>
              移动端体验
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-background-50 leading-tight">
              YY漫画APP - 口袋里的漫画图书馆
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-50/80 leading-relaxed max-w-lg mx-auto lg:mx-0">
              支持iOS和Android双平台，流畅的下拉式阅读体验、智能弹窗阅读模式、仿真翻页阅读效果，配合高清画质引擎，让每一页漫画都栩栩如生。离线缓存功能让你随时随地畅享韩漫日漫。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-6">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-foreground-900 font-bold text-sm rounded-full cursor-pointer whitespace-nowrap hover:bg-background-100 transition-colors">
                <i className="ri-apple-fill text-lg"></i>
                iOS 下载
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/90 text-foreground-900 font-bold text-sm rounded-full cursor-pointer whitespace-nowrap hover:bg-background-100 transition-colors">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </span>
            </div>
          </div>
          <div className="flex-shrink-0 px-8 pb-8 lg:pb-0 lg:pr-12 lg:pl-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20floating%20smartphone%20mockup%20displaying%20a%20comic%20reading%20app%20home%20screen%20with%20colorful%20manga%20thumbnails%2C%20warm%20orange%20and%20amber%20UI%20accents%2C%20modern%20clean%20interface%20design%2C%20vibrant%20comic%20cover%20art%20visible%2C%20device%20floating%20with%20soft%20shadow%20on%20transparent%20background%2C%20product%20mockup%20photography%20style%2C%20minimal%20composition&width=600&height=800&seq=app-mockup-comic-01&orientation=portrait"
              alt="YY漫画APP移动端界面展示"
              title="YY漫画APP口袋漫画图书馆"
              className="w-[240px] md:w-[280px] object-cover rounded-2xl"
              style={{ aspectRatio: '3/4' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}